/* eslint-disable no-param-reassign */
import { ActionTree, Module } from 'vuex';
import { RootState } from '../types';

interface ConfigState {
  clientId: string | null;
  redirectUri: string | null;
  contactUsUrl: string;
}

const state = (): ConfigState => ({
  contactUsUrl: '',
  clientId: null,
  redirectUri: null,
});

interface SetInitialStatePayload {
  clientId?: string;
  redirectUri?: string;
}

const actions: ActionTree<ConfigState, RootState> = {
  async initialiseConfigState({ commit }, payload: SetInitialStatePayload) {
    let contactUsUrl;
    switch (payload.clientId) {
      case 'QSIS':
        contactUsUrl = 'https://www.sclqld.org.au/about-us/contact-us';
        break;
      default:
        contactUsUrl = 'https://www.judcom.nsw.gov.au/contact-us/';
    }

    commit('SET_CONFIG', {
      clientId: payload.clientId,
      redirectUri: payload.redirectUri,
      contactUsUrl,
    });
  },
};

const mutations = {
  SET_CONFIG(s: ConfigState, config: any): void {
    s.clientId = config.clientId || null;
    s.redirectUri = config.redirectUri || null;
    s.contactUsUrl = config.contactUsUrl;
  },
};

const getters = {
  redirectUri: (s: ConfigState, __: any, rootState: any): string | undefined => {
    if (s.redirectUri) {
      return s.redirectUri;
    }

    const { user } = rootState?.Auth;

    if (!user) {
      return undefined;
    }

    const clients = (user && user.clients) || [];
    const client = s.clientId && clients.find((c: any) => c.client === s.clientId);

    if (client) {
      return client.url;
    }

    if (clients.length === 1) {
      return clients[0].url;
    }
    return undefined;
  },

  contactUsUrl: (s: ConfigState): string => {
    return s.contactUsUrl;
  },

  clientId: (s: ConfigState): string | undefined => {
    return s.clientId || undefined;
  },
};

const store: Module<ConfigState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default store;
